/**
 * Format a listing location for public display.
 *
 * - Verified suppliers (real registered businesses) get their FULL address
 *   shown — they're public-facing brick-and-mortar yards, that's how buyers
 *   find them.
 * - External aggregator listings (Gumtree / Facebook Marketplace / Craigslist —
 *   private individuals) get only the suburb / state / country shown, never
 *   street numbers or names. Protects sellers' personal safety since we
 *   mirrored their listings without explicit consent.
 * - Anything else (a not-yet-verified supplier waiting in the queue) defaults
 *   to the safe abbreviated form too.
 *
 * Examples (privacy-protecting form):
 *   "12 Smith St, Adelaide, SA, 5000, Australia" → "Adelaide, SA, Australia"
 *   "Adelaide, SA"                              → "Adelaide, SA"
 *   "Brisbane"                                  → "Brisbane"
 *   ""                                          → ""
 */
export function formatListingLocation(listing) {
  if (!listing) return '';
  const loc = listing.location || '';
  // Verified business → show as-is. They're a real yard with a public address.
  if (listing.is_verified_seller && !listing.external_source) {
    return loc;
  }
  return _abbreviate(loc);
}

/** Lower-level helper — kept exported for places that have a raw string but
 *  no listing object handy. Always returns the abbreviated form. */
export function formatPublicLocation(loc) {
  return _abbreviate(loc);
}

function _abbreviate(loc) {
  if (!loc || typeof loc !== 'string') return '';
  const parts = loc
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean)
    .filter((p) => {
      const lower = p.toLowerCase();
      if (/^\d+$/.test(p)) return false;
      if (/^\d+\s/.test(p)) return false;
      if (/\b(st|street|rd|road|ave|avenue|blvd|boulevard|ln|lane|cres|crescent|dr|drive|hwy|highway|ct|court|pl|place|tce|terrace|pde|parade|way)\b\.?$/i.test(lower)) return false;
      return true;
    });
  return parts.slice(-3).join(', ');
}
